__turbopack_context__.v({
  "body": "BuyMeACoffeePopover-module__j48spW__body",
  "cta": "BuyMeACoffeePopover-module__j48spW__cta",
  "iconDefault": "BuyMeACoffeePopover-module__j48spW__iconDefault",
  "iconHover": "BuyMeACoffeePopover-module__j48spW__iconHover",
  "text": "BuyMeACoffeePopover-module__j48spW__text",
  "title": "BuyMeACoffeePopover-module__j48spW__title",
  "wrapper": "BuyMeACoffeePopover-module__j48spW__wrapper",
});
